import classNames from 'classnames';
import { getSearch } from 'connected-react-router';
import * as queryString from 'query-string';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import styles from './collection.module.scss';

import { ReactComponent as IconCollection } from '../../../../../assets/images/collection.svg';
import { ReactComponent as FilterBubble } from '../../../../../assets/images/filter-bubble-red.svg';
import { collectionProductsData } from '../../../../../store/collection';
import { AppState } from '../../../../../store/store';
import { togglePopup } from '../../../../../store/ui';
import { useMedia } from '../../../../context/InterfaceContext';

export const CollectionButton = () => {
    const dispatch = useDispatch();
    const intl = useIntl();
    const collectionProducts = useSelector(collectionProductsData);
    const count = collectionProducts.length;
    const { isMobileOrTablet } = useMedia();
    const search = useSelector((state: AppState) => getSearch(state));
    const searchParams: queryString.ParsedQuery = queryString.parse(search, { arrayFormat: 'comma' });

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(() => {
        if (searchParams.share && +searchParams.share === 1) {
            dispatch(togglePopup({ name: 'collection', status: true }));
        }
    }, []);
    /* eslint-enable react-hooks/exhaustive-deps */

    return (
        <div
            className={classNames(styles.collectionButton)}
            onClick={() => dispatch(togglePopup({ name: 'collection', status: true }))}
        >
            <IconCollection />

            {isMobileOrTablet ? (
                !!count && count
            ) : (
                <>
                    {intl.formatMessage({ id: 'collection.nameOpenButton', defaultMessage: 'Merkliste' })}
                    {!!count && <FilterBubble className={classNames(styles.bubble)} />}
                    <span
                        className={classNames(styles.bubble__text, {
                            [styles.bubble__text_wider]: count > 9 && count < 100,
                        })}
                    >
                        {!!count && `${count}`}
                    </span>
                </>
            )}
        </div>
    );
};
